module.exports = __webpack_public_path__ + "static/media/peloton.51fd2774.jpg";